import { makeStyles } from '@material-ui/core/styles';

// const drawerWidth = 0;

export default makeStyles((theme) => ({
  button: {
      color: '#AEB4BE',
      // padding: '0.3rem 0rem',
      margin: '2px 0px',
      padding: '0px'
  }
}));